import { DetailsList, MarqueeSelection, Selection, SelectionMode, GroupHeader } from 'office-ui-fabric-react';
import React, { Component } from 'react';
import { MyContext } from '../../../context';

export default class AIAssistantsListView extends Component {
    static contextType = MyContext
    _selection: Selection;

    constructor(props) {
        super(props);
        this._selection = new Selection({
            onSelectionChanged: () => {
                this.props.selectAIAssistant(this._selection.getSelection().length > 0 ? this._selection.getSelection()[0].id : null)
            }
        });
    }

    _getKey = (item, index) => {
        return item.key;
    }

    render() {
        var columns = [
            { key: 'name', name: this.context.getTranslation("compliance", "detailPolicyName"), fieldName: 'name', minWidth: 100, maxWidth: 200, isResizable: true },
            { key: 'description', name: this.context.getTranslation("compliance", "detailPolicyDescription"), fieldName: 'description', minWidth: 100, maxWidth: 200, isResizable: true },
            { key: 'question', name: this.context.getTranslation("configuration", "QuestionColumn"), fieldName: 'question', minWidth: 100, maxWidth: 200, isResizable: true },
            {
                key: 'active',
                name: this.context.getTranslation("compliance", "detailPolicyActive"),
                fieldName: 'active',
                minWidth: 50,
                maxWidth: 80,
                onRender: (item: IDocument) => {
                    return <span>{item.active ? this.context.getTranslation("common", "yes") : this.context.getTranslation("common", "no")}</span>
                }
            },
            {
                key: 'logInteraction',
                name: this.context.getTranslation("compliance", "logInteraction"),
                fieldName: 'logInteraction',
                minWidth: 50,
                maxWidth: 180,
                onRender: (item: IDocument) => {
                    return <span>{item.logInteraction ? this.context.getTranslation("common", "yes") : this.context.getTranslation("common", "no")}</span>
                }
            },
            {
                key: 'automated',
                name: this.context.getTranslation("compliance", "automated") + " / " + this.context.getTranslation("compliance", "ondemand"),
                fieldName: 'automated',
                minWidth: 100,
                maxWidth: 180,
                onRender: (item: IDocument) => {
                    return <span>{item.automated ? this.context.getTranslation("compliance", "automated") : this.context.getTranslation("compliance", "ondemand")}</span>
                }
            }
        ]

        if (this.props.userRules.ruleAccess.userComplianceAIAssistant && this.props.userRules.visibilityDetailsAIAssistantHistory) {
            columns = [...columns, {
                key: 'saveResult',
                name: this.context.getTranslation("compliance", "saveResult"),
                fieldName: 'saveResult',
                minWidth: 50,
                maxWidth: 50,
                onRender: (item: IDocument) => {
                    return <span>{item.saveResult ? this.context.getTranslation("common", "yes") : this.context.getTranslation("common", "no")}</span>
                }
            }]
        }

        return (
            <MarqueeSelection selection={this._selection}>
                <DetailsList
                    items={this.props.aiQuestions}
                    groups={this.props.aiQuestionsGroup}
                    groupProps={{
                        onRenderHeader: (props) => {
                            return (
                                <GroupHeader
                                    {...props}
                                    onToggleCollapse={(group) => {
                                        let groupsCollapsed = this.props.groupsCollapsed.map(g => {
                                            return g.key === group.key ? { ...g, isCollapsed: !g.isCollapsed } : g
                                        })
                                        this.props.getGroupsCollapsed(groupsCollapsed)
                                        if (props.onToggleCollapse) {
                                            props.onToggleCollapse(group)
                                        }
                                    }}
                                />
                            )
                        }
                    }}
                    columns={columns}
                    selectionMode={SelectionMode.single}
                    selection={this._selection}
                    getKey={this._getKey}
                    setKey="single"
                    onRenderItemColumn={this._renderItemColumn}
                />
            </MarqueeSelection>
        );
    }
}